import { BANK_DETAILS } from "../../actions/trainer/bank_details_action";

const initState = {
  is_done: false,
  loading: false,
  errors: [],
  list: [],
  bankDetails: {},
};

const bankDetailsReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case BANK_DETAILS.ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
        is_done: false,
      };

    case BANK_DETAILS.REQUEST:
      return {
        ...state,
        loading: true,
        is_done: false,
        errors: [],
        list: [],
        bankDetails: {},
      };

    case BANK_DETAILS.ADD_BANK_DETAILS:
    case BANK_DETAILS.UPDATE_BANK_DETAILS:
    case BANK_DETAILS.DELETE_BANK_DETAILS:
      return {
        ...state,
        loading: false,
        is_done: true,
        errors: [],
      };

    case BANK_DETAILS.GET_BANK_DETAILS:
      return {
        ...state,
        loading: false,
        is_done: false,
        errors: [],
        list: [],
        bankDetails: payload,
      };
    case BANK_DETAILS.GET_LIST_BANK_DETAILS:
      return {
        ...state,
        loading: false,
        is_done: false,
        errors: [],
        list: payload,
      };
    default:
      return state;
  }
};

export default bankDetailsReducer;
